import { testimonials } from '@/mocks/novels';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            读者口碑
          </h2>
          <p className="text-sm text-foreground-500">来自真实读者的评价与反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className={`text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{t.comment}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}